import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=73d8ed1d&scoped=true&"
import script from "./Courses.js?vue&type=script&lang=js&"
export * from "./Courses.js?vue&type=script&lang=js&"
import style0 from "./Courses.scss?vue&type=style&index=0&id=73d8ed1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d8ed1d",
  null
  
)

export default component.exports